export enum SelectedCreditor {
ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION = "ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION",
ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_SUCCESS = "ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_SUCCESS",
ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_FAIL = "ADD_NEW_CREDITOR_AUTHORIZED_INFORMATION_FAIL",
}